import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { GoogleTagAnalyticsService } from '../../../../../services/google-tag/google-tag-analytics.service';
import { EGoogleTagAnalyticsKeys } from '../../enums';
import { EPastType, IPastAPI, Match } from '../models';

const PAGE_SIZE = 10;

@Injectable({
  providedIn: 'root',
})
export class MatchPastService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);

  isLoadingPast = signal<boolean>(false);
  isErrorPast = signal<boolean>(false);
  past = signal<IPastAPI | null>(null);

  private accumulatedMatches = signal<Match[]>([]);

  getMatchPast(
    matchId: string,
    type: EPastType,
    page: number = 1,
    reset = false
  ) {
    this.isErrorPast.set(false);
    this.isLoadingPast.set(true);

    this.http
      .get<IPastAPI>(`${this.env.baseUrlWeb}/matches/${matchId}/past`, {
        headers: this.headers,
        params: { type, page, size: PAGE_SIZE },
      })
      .pipe(
        catchError(() => {
          this.isLoadingPast.set(false);
          this.isErrorPast.set(true);
          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) return;

        const current = reset ? [] : this.accumulatedMatches();
        const combined = [...current, ...(data.Matches || [])];

        this.accumulatedMatches.set(combined);
        this.past.set({ ...data, Matches: combined });

        this.isLoadingPast.set(false);

        // google analytics
        this.googleTagAnalyticsService.event(
          EGoogleTagAnalyticsKeys.VIEW_HEAD_TO_HEAD,
          {
            match_id: matchId,
            h2h: data,
          }
        );
      });
  }

  resetMatches() {
    this.accumulatedMatches.set([]);
  }
}
